import { useSelector } from 'react-redux';

import getUnitSelector from '/business/shared/state/selectors/units/getUnitSelector';

type UnitEntry = {
  isDefault?: boolean;
  isPreferredUnit?: boolean;
  unitId: string;
};

type EmissionUnitData = {
  systemId: string;
  units: UnitEntry[];
};

type UnitDataState = {
  collection?: EmissionUnitData[];
};

export default function useGetDefault(emissionTypeId: string): string | null {
  const unitData = useSelector(getUnitSelector) as UnitDataState;
  if (unitData && unitData.collection && unitData.collection.length > 0) {
    const locatedEmission = unitData.collection.find((emission) => {
      return emission.systemId === emissionTypeId;
    });
    if (locatedEmission) {
      let unit = locatedEmission.units.find((unit) => {
        return unit.isPreferredUnit;
      });
      if (!unit) {
        unit = locatedEmission.units.find((unit) => {
          return unit.isDefault;
        });
      }
      if (!unit) {
        return null;
      }
      return unit.unitId;
    }
  }
  return null;
}
